import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { FormatedSavedFilter } from "@teammood/filter";
import { ITeam } from "@teammood/team";
import { Subject } from "rxjs";
import { After } from "v8";

@Component({
    selector: 'empty-taskbook-redirection-dialogg',
    templateUrl: './empty-taskbook-redirection-dialog.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatDialogModule,
        MatDialogTitle,
        MatDialogContent,
]
  })
  export class EmptyTaskbookRedirectionDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  
    teamName: string;
    hasMoreItemsInOtherTeams: boolean;
    countdown: number = 10;
    private intervalId: any;

    private _destroy$ = new Subject<void>();
  
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: EmptyTaskbookRedirectionDialogData,
      private dialogRef: MatDialogRef<EmptyTaskbookRedirectionDialogComponent>,
    ) { }
  
    ngOnInit(): void {
        this.teamName = this.data.filter.name;
        this.hasMoreItemsInOtherTeams = this.data.hasMoreItemsInOtherTeams;
    }

    ngAfterViewInit() {
        this.startCountdown();
    }
    ngOnDestroy() {
        this.clearInterval();
        this._destroy$.next();
        this._destroy$.complete();
    }

    startCountdown(): void {
        this.intervalId = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            this.clearInterval();
            this.dialogRef.close({
                redirect: true,
                hasMoreItemsInOtherTeams: this.hasMoreItemsInOtherTeams
            });
          }
        }, 1000);
      }
    
    clearInterval(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    go(){
        this.dialogRef.close({
            redirect: true,
            hasMoreItemsInOtherTeams: this.hasMoreItemsInOtherTeams
        });
    }

    cancel() {
        this.clearInterval();
        this.dialogRef.close();
    }

}


export interface EmptyTaskbookRedirectionDialogData {
    filter: FormatedSavedFilter,
    hasMoreItemsInOtherTeams: boolean
}